// Import 3rd-party dependencies
import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

// Import  ject-specific dependencies
import { EnterpriseSearchService, ISearchResultItem } from '@app/services/enterprise-search/enterprise-search.service';
import { TRENDING_DOCS_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-trending-documents',
  templateUrl: './trending-documents.component.html',
  styleUrls: ['./trending-documents.component.css']
})
export class TrendingDocumentsComponent implements OnInit {
  @Input() fs: number;
  @Input() ls: number;

  trendingDocuments: ISearchResultItem[];

  consts = TRENDING_DOCS_COMPONENT_CONSTS;

  constructor(private enterpriseService: EnterpriseSearchService, private _snackBar: MatSnackBar) {}

  ngOnInit(): void { 
    this.enterpriseService.trendingSearch$.subscribe((trending) => {
      if (trending) {
        this.trendingDocuments = trending;
      }
    });
  }

  openLink(url: string): void {
    window.open(url, '_blank');
  }

  openSnackBar(): void {
    this._snackBar.open(this.consts.MESSAGE_COPY_LINK, undefined, {
      duration: this.consts.SNACKBAR_DURATION
    });
  }
}
